import { render, staticRenderFns } from "./ViewExternal.vue?vue&type=template&id=3688b47c&scoped=true"
import script from "./ViewExternal.vue?vue&type=script&lang=js"
export * from "./ViewExternal.vue?vue&type=script&lang=js"
import style0 from "./ViewExternal.vue?vue&type=style&index=0&id=3688b47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688b47c",
  null
  
)

export default component.exports